import React, {useState} from 'react';
import 'contents/assets/scss/page/main.scss';
import Paging from '../../component/Inc/Paging';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopAddMember from './_PopAddMember';
import Calendar from '../../component/Inc/Calendar';
function NewMember() {
  const [modalAddMember, setModalAddMember] = useState(false);
  return (
    <main className="com_container p_new">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_5">새로 오신 이지가족</h2>
          <button onClick={() => setModalAddMember(true)} className="com_btn orange s btn_plus">
            이지가족 추가
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <Calendar />
            <div className="member_massge">입사를 축하합니다!</div>
            <div className="com_card_list">
              <div className="card_item">
                <div className="item_top">
                  <div className="info">
                    <p className="name">홍보</p>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                    </div>
                  </div>
                </div>
                <div className="item_mid">
                  <div className="info_area center">
                    <p className="thumb">
                      <img src={ImgProfile} alt="profile" />
                    </p>
                    <div className="info_box">
                      <button className="name btn_link">홍길동103</button>
                      <span className="desc">선생님</span>
                      <ul className="detail">
                        <li className="detail_item">
                          <p className="tit">입사일자 : </p>
                          <p>2022, 06, 09</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="item_bt">
                  <p className="txt">
                    최선을 다해 가르치겠습니다.
                    <br />
                    최선을 다해 가르치겠습니다.
                  </p>
                </div>
              </div>
              {[1, 2, 3, 4].map((i, idx) => {
                return (
                  <div className="card_item" key={idx}>
                    <div className="item_top">
                      <div className="info">
                        <p className="name">내근직</p>
                        <div className="com_btn_wrap">
                          <button className="btn_edit"></button>
                        </div>
                      </div>
                    </div>
                    <div className="item_mid">
                      <div className="info_area center">
                        <p className="thumb">
                          <img src={ImgProfile} alt="profile" />
                        </p>
                        <div className="info_box">
                          <button className="name btn_link">홍길동103</button>
                          <span className="desc">선생님</span>
                          <ul className="detail">
                            <li className="detail_item">
                              <p className="tit">수업영역 : </p>
                              <p>영어 (화상)</p>
                            </li>
                            <li className="detail_item">
                              <p className="tit">수업지역 : </p>
                              <p>금천</p>
                            </li>
                            <li className="detail_item">
                              <p className="tit">입사일자 : </p>
                              <p>2022, 06, 09</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="item_bt">
                      <p className="txt">최선을 다해 가르치겠습니다.</p>
                    </div>
                  </div>
                );
              })}
              <div className="card_item">
                <div className="item_top">
                  <div className="info">
                    <p className="name">전략기획실</p>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                    </div>
                  </div>
                </div>
                <div className="item_mid">
                  <div className="info_area center">
                    <p className="thumb">
                      <img src={ImgProfile} alt="profile" />
                    </p>
                    <div className="info_box">
                      <button className="name btn_link">홍길동103</button>
                      <span className="desc">선생님</span>
                      <ul className="detail">
                        <li className="detail_item">
                          <p className="tit">수업영역 : </p>
                          <p>영어 (화상)</p>
                        </li>
                        <li className="detail_item">
                          <p className="tit">수업지역 : </p>
                          <p>금천</p>
                        </li>
                        <li className="detail_item">
                          <p className="tit">입사일자 : </p>
                          <p>2022, 06, 09</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="item_bt">
                  <p className="txt">최선을 다해 가르치겠습니다.최선을 다해 가르치겠습니다.최선을 다해 가르치겠습니다.</p>
                </div>
              </div>
            </div>
            <Paging />
            <hr className="com_divider" />
            <div className="com_comment_wrap type_box">
              <ul className="comment_list">
                {[1, 2, 3, 4, 5].map((i, idx) => {
                  return (
                    <li className="item" key={idx}>
                      <div className="info">
                        <p className="name">홍길동104</p>
                        <span className="dot" />
                        <p className="date">2023.05.20 11:30</p>
                      </div>
                      <p className="txt">
                        22년 총 수업 700타임 이상 유지율 100%를 달성하셨습니다. <br />
                        축하드려요~!
                      </p>
                      <div className="com_btn_wrap">
                        <button className="btn_edit"></button>
                        <button className="btn_delete"></button>
                      </div>
                    </li>
                  );
                })}
                <li className="item">
                  <div className="info">
                    <p className="name">홍길동104</p>
                    <span className="dot" />
                    <p className="date">2023.05.20 11:30</p>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                      <button className="btn_delete"></button>
                    </div>
                  </div>
                  <p className="txt">
                    축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!
                    <br />
                    축하드려요~!
                  </p>
                </li>
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">댓글 등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopAddMember open={modalAddMember} close={() => setModalAddMember(false)} />
    </main>
  );
}

export default NewMember;
